/*Link Ids For V2*/
export class SegmentReferenceIds {
  segmentId: number;
  guestId: number;
  constructor(segment?: number, guest?: number) {
    this.segmentId = segment;
    this.guestId = guest;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/segmentReferenceIds.model.ts